import React from 'react'
import { Box, Button, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import FlightDetailsHeadings from './flightDetailsHeadings';
import { FlightDetailsTabKey } from './flightDetails';

interface FlightDetailsHeaderProps {
    onClose : () => void,
    headings: { key: FlightDetailsTabKey; label: string }[],
    selectedDetails : FlightDetailsTabKey
    setSelectedDetails : (details : FlightDetailsTabKey) => void
}

const FlightDetailsHeader: React.FC<FlightDetailsHeaderProps> = ({
    onClose,
    headings,
    selectedDetails,
    setSelectedDetails
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid',
                borderColor: 'grey.200',
                my: '0.25rem'
            }}
        >
            {headings.map((heading,index) => (
                <FlightDetailsHeadings key={index} heading={heading} selectedDetails={selectedDetails} setSelectedDetails={setSelectedDetails} />
            ))}
            <IconButton onClick={onClose}>
                <CloseIcon sx={{ fontSize: '1.3rem' }} />
            </IconButton>
        </Box>
    )
}

export default FlightDetailsHeader